import { PaginationRequest } from '../config/common';

export class PaginationSurchargeRequest extends PaginationRequest {
    name?: string = '';
    code?: string = '';
    codePrice?: number;
    sellingPrice?: number;
    surchargeTypeID?: number;
}

export interface CreateSurchargeRequest {
    name?: string;
    code?: string;
    codePrice?: number;
    sellingPrice?: number;
    surchargeTypeID?: number;
}
